export const NEXT_BUTTON = 'Next'
export const BACK_BUTTON = 'Back'
